import React, { useEffect, useState } from "react";
import { Table, Row, Col, Select, Form, DatePicker, Input, Button, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { dropdownService, reportService } from "../../../services";
import { handlePDFDownload, handlePrint, exportToExcel } from "../../../utils/printing";

const { Title } = Typography;

function InvoiceCollectionDueCopy() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [cashFlow, setCashFlow] = useState([]);
  const [allcashFlow, setAllCashFlow] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [payload, setPayload] = useState(null);
  const [customers, setCustomers] = useState([]);
  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
    },
    {
      title: "Invoice No",
      dataIndex: "Invoice No",
      key: "Invoice No",
    },
    {
      title: "Username",
      dataIndex: "User Name",
      key: "User Name",
    },
    {
      title: "Due Date",
      dataIndex: "Due Date",
      key: "Due Date",
    },
    {
      title: "Payment Date",
      dataIndex: "Payment Date",
      key: "Payment Date",
    },
    {
      title: "Days Due",
      dataIndex: "Days Due",
      key: "Days Due",
    },
  ];

  const onFinish = (values) => {
    const payload = Object.fromEntries(
      Object.entries({
        ...values,
        from_date: values.from_date?.format("YYYY-MM-DD"),
        to_date: values.to_date?.format("YYYY-MM-DD"),
      }).filter(([_, value]) => value != null)
    );
    setPayload(payload);
    initialize(pagination.current, pagination.pageSize, payload);
  };

  const initialize = async (
    page = 1,
    pageSize = pagination.pageSize,
    payload = null
  ) => {
    setLoading(true);
    const { success, data } = await reportService.CashFlowDue(page, payload);
    setLoading(false);
    if (success) {
      setCashFlow(data);
      setPagination((prev) => ({
        ...prev,
        total: data.pagination.total,
        current: page,
        pageSize,
      }));
      getAll();
    }
    setLoading(false);
  };

  const getCustomers = async () => {
    const response = await dropdownService.fetchCustomers();
    if (response.success) {
      setCustomers(response.data);
    }
  };

  const getAll = async () => {
    const { success, data } = await reportService.CashFlowDue(payload, true);
    setLoading(false);
    if (success) {
      setAllCashFlow(data.data);
    }
  }


  useEffect(() => {
    getCustomers();
  }, []);
  return (
    <>
      <Title level={5}>
        CF - Invoice Collection Due Vs Actual Collection Copy
      </Title>

      <Form
        requiredMark={false}
        layout="vertical"
        form={form}
        onFinish={onFinish}
      >
        <Row gutter={24} className="mt-8">
          <Col span={6}>
            <Form.Item label="From date" name="from_date">
              <DatePicker style={{ width: "100%" }} placeholder="Select Date" />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item label="To date" name="to_date">
              <DatePicker style={{ width: "100%" }} placeholder="Select Date" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Customers" name="user_id">
              <Select placeholder="">
                {customers.map((cust) => (
                  <Select.Option key={cust.id} value={cust.id}>
                    {cust.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={2}>
            <Form.Item label={<></>}>
              <Button type="primary" htmlType="submit">
                <SearchOutlined style={{ fontSize: "15px" }} />
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Col span={24}>
        <Row
          gutter={0}
          style={{
            padding: "8px",
            marginTop: "2px",
            background: "#F2F2F7",
            borderRadius: "4px",
          }}
          className="flex justify-between"
        >
          <Col span={12}>
            <div className="flex">
              <Button onClick={() => handlePrint(allcashFlow, columns, "Invoice Collection Due vs Actual Collection Copy")} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }} >
                <span style={{ fontWeight: "bold", padding: "3px" }}>Print</span>
              </Button>

              {/* <Button type='text' size='small' style={{ padding: '4px' }}>
                <FaRegFile style={{ fontSize: "20px" }} />
              </Button> */}

              <Button onClick={() => exportToExcel(allcashFlow, "Invoice_Collection_Due.xslx")} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }}>
                <span style={{ fontWeight: "bold", padding: "3px" }}>Excel</span>
              </Button>

              <Button onClick={() => handlePDFDownload(allcashFlow, columns, "Invoice Collection Due vs Actual Collection Copy", false)} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }}>
                <span style={{ fontWeight: "bold", padding: "3px" }}>PDF</span>
              </Button>

              {/* <Button type='text' size='small' style={{ padding: '4px' }}>
                <RiFileCopyLine style={{ fontSize: "24px" }} />
              </Button> */}
            </div>
          </Col>
          <Col span={12} style={{ textAlign: "right" }}>
            <Input
              placeholder="Search"
              prefix={<SearchOutlined />}
              className="w-auto lg:w-2/5"
            />
          </Col>
        </Row>
        <div id="printable-table">
          <Table
            columns={columns}
            scroll={{ x: "max-content" }}
            pagination={{
              current: pagination.current,
              total: pagination.total,
              pageSize: pagination.pageSize,
              onChange: (page) => initialize(page, pagination.pageSize, payload),
              showSizeChanger: false,
            }}
            loading={loading}
            dataSource={cashFlow.data}
            style={{ marginTop: "10px" }}
          />
        </div>
      </Col>
    </>
  );
}

export default InvoiceCollectionDueCopy;
